
(function () {
  'use strict';
  angular.module('vcexamtemplate')
    .component('examtemplateeditor', {
      restrict: 'E',
      bindings: {
        examtemplate: '<?',
        examtemplateid: '<?'
      },
      template: `
        <examtemplateform examtemplate="vm.examtemplate" parentsave="vm.childsave(examtemplate)" oncancel="vm.oncancel()">
        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> examtemplate erfolgreich gespeichert!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen examtemplate wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> examtemplate konnte nicht gespeichert werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Examtemplate', 'Rlog',
        function ($log, Examtemplate, Rlog) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;
          vm.oncancel = oncancel;
          
          vm.$onInit = function () {
            if ((angular.isUndefined(vm.examtemplate) || !vm.examtemplate.hasOwnProperty('_id'))
              && angular.isDefined(vm.examtemplateid)) {
              Examtemplate.$find(vm.examtemplateid).$then(function (examtemplate) {
                vm.examtemplate = examtemplate;
              }, function (err) {
                $log.error('examtemplate not found, id: ', vm.examtemplateid);
                Rlog.error('examtemplate', 'examtemplateeditor', 'examtemplate not found', {_id: vm.examtemplateid});
              });
            }
          };


          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.examtemplateid) && angular.isDefined(changes.examtemplateid.currentValue) && changes.examtemplateid.currentValue.length > 0) {
              vm.examtemplateid = changes.examtemplate.currentValue;
              Examtemplate.$find(vm.examtemplateid).$then(function (examtemplate) {
                vm.examtemplate = examtemplate;
              }, function (err) {
                $log.error('examtemplate not found, id: ', vm.examtemplateid);
                Rlog.error('examtemplate', 'examtemplateeditor', 'examtemplate not found', {_id: vm.examtemplateid});
              });
            }
          };


          function childsave(examtemplate) {
            // vm.examtemplate = angular.copy(examtemplate);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in examtemplate) {
              if (examtemplate.hasOwnProperty(key)) {
                vm.examtemplate[key] = examtemplate[key];
              }
            }
            vm.save();
          }
          
          function save() {
            if (vm.examtemplate.$hasPendingActions()) {
              vm.examtemplate.$cancel();
              vm.examtemplate.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of examtemplate failed: ', err);
                Rlog.error('vcutils.examtemplate', 'examtemplateeditor', 'Saving of examtemplate failed: ', {error: err, examtemplateid: vm.examtemplate._id});
              });
            }
            else {
              vm.examtemplate.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of examtemplate failed: ', err);
                Rlog.error('vcutils.examtemplate', 'examtemplateeditor', 'Saving of examtemplate failed: ', {error: err, examtemplateid: vm.examtemplate._id});
              });
            }
          }
          
          function oncancel() {
            vm.canceled = true;
          }
          
          
        }] // controller
    }); // component

// klammerfriedhof
}());